import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({

  //title
  popUpTitle: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: "row",
    padding: "24px 20px 0 20px"

  },
  popUpTitleIcon: {
    position: 'relative',
    top: "5px",
  },
  popUpTitleTPName: {
    color: "#2E2E3A",
    fontSize: "16px",
    fontWeight: "400",
  },

  //Progress bar
  progressBarWrapper: {
    width: 'calc(100%)',
    borderTop: "1px solid #E2E2EA",

    backgroundColor: '#E2E2EA',
  },
  progressBarStep: {
    backgroundColor: theme.palette.primary.primary500,
    height: "1.5px",
  },

  // Notice
  noticeWrapper: {
    backgroundColor: '#F5F5F5',
    border: '1px solid #F5F5F5',
    padding: '13px',
    marginBottom: '10px',
    marginTop: "26px",
    borderRadius: "16px",
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre-wrap',
  },
  lightIcon: {
    marginRight: "10px"
  },

  // Formulaire
  mainContentWrapper: {
    marginTop: "20px"
  },
  formPartWrapper: {
    display: "flex",
    flexDirection: "row"
  },
  formPartTitle: {
    width: "230px",
    color: theme.palette.primary.primary500,
    fontWeight: "700",
    position: 'relative',
    top: "18px",
    fontSize: "14px",
  },
  formPartTitleAttributes: {
    width: "230px",
    color: theme.palette.primary.primary500,
    fontWeight: "700",
    fontSize: "14px",
    position: "relative",
    top: "-28px"
  },
  formPartContent: {
    flex: 1,
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#E2E2EA',
    margin: "24px 0"
  },
  formIcon: {
    position: 'relative',
    top: "2px",
    width: '20px',
  },
  formIconAttributes: {
    marginRight: "0px",
    position: 'relative',
    top: "20px",
    width: '30px',
    height: '30px',
  },
  formLabel: {
    fontWeight: "600",
    color: "#7E7E8F",
    fontSize: "14px",
  },
  formContainerAttributes: {
    display: 'flex',
    flexDirection: 'column',
    border: "1px solid #F2F3F7",
    backgroundColor: "#FCFDFD",
    padding: "13px",
    maxWidth: "600px",
    alignItems: "flex-start",
  },
  input: {
    "& .MuiOutlinedInput-root": {
      border: "none",
    },
  },
  inputDevise: {
    "& .MuiOutlinedInput-root": {
      border: "none",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    }
  },
  inputError: {
    "& .MuiOutlinedInput-root": {
      fontSize: "14px",
      fontWeight: 400,
      borderRadius: "16px",
      height: "40px",
      border: "2px solid " + theme.palette.error.error300,
      color: theme.palette.error.error600,

      "& .MuiOutlinedInput-notchedOutline": {
        border: "0px solid #FFCCCC !important",
      },
    },

    "& .Mui-error": {
      color: theme.palette.error.error600,
    },
  },

  // attributs
  attributeItemWrapper: {
    display: "flex",
    flexDirection: "row",
    margin: "5px",
    borderRadius: "12px",
    boxShadow: "none",
    width: "100%",
  },
  attributeItemLabel: {
    backgroundColor: theme.palette.primary.primary200,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "1rem",
    padding: "3px 2px",
    borderRadius: "12px 0 0 12px",
    boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
    flex: "0 1 auto",
  },
  attributeItemLabelDossier: {
    backgroundColor: "#EBFAEE",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "1rem",
    padding: ".5rem 1rem",
    borderRadius: "12px 0 0 12px",
    flex: 1
  },
  attributeName: {
    fontSize: "14px",
    color: "#373534",
    fontWeight: 700,
    fontFamily: "Inter",
    padding: "2px 13px",
  },
  attributeNameDossier: {
    fontSize: "14px",
    color: "#373534",
    fontWeight: 700,
    fontFamily: "Inter",
    padding: "2px 13px",
  },
  attributeItemImg:{
    position: "relative",
    top: "2px",
  },
  breakWord:{
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineClamp: 1,
    boxOrient: "vertical",
    whiteSpace: "nowrap",
  },
  attributeItemDate: {
    padding: ".5rem 1rem",
    backgroundColor: "white",
    minWidth: "97px",
    display: "flex",
    gap: "5px",
    border: "1px solid " + theme.palette.grey.grey100,
    borderRadius: "16px",
    position: 'absolute',
    right: "8px", top: 0
  },
  attributeItemDateModifyLabel: {
    color: theme.palette.error.error600,
    fontSize: "12px",
    fontWeight: 700,
  },
  attributeItemDateModifyDate: {
    color: theme.palette.grey.grey700,
    fontSize: "12px",
    fontWeight: 400,
  },
  attributeDateIcon: {
    width: "15px",
  },
  attributeItemValues: {
    padding: ".1rem .8rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: "0 12px 12px 0",
    boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
  },
  shownValues:{
    fontSize: "12px",
    color:  theme.palette.black.dark,
    display: "flex",
    alignItems: "center",
    flex: 1,
    minWidth: 0,
  },
  noDataRootDossier: {
    backgroundColor: "white",
    padding: "12px",
    borderRadius: "0 12px 12px 12px",
  },
  noDataRootThird: {
    backgroundColor: "white",
    padding: "12px",
    marginRight: "16px",
    borderRadius: "0 12px 12px 12px",
  },
  attributesItemColor: {
    width: "22px",
    height: "22px",
    border: "1px solid white",
    borderRadius: "4px",
    marginRight: "6px",
    flex: "0 0 auto",
  },
  attributeItemValuesEdit: {
    marginLeft: "4px",
  },
  placeholderValue: {
    color: "#9A9AAF",
    fontSize: '14px',
    whiteSpace: "nowrap",
  },
  requieredInfos: {
    color: "#CC0001",
    fontSize: "12px",
    fontWeight: 400,
    marginLeft: "7px",
    marginBottom: "7px",
  },
  wrapWord: {
    wordWrap: "break-word",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
  thirdPartyUnmanaged: {
    background: "#EEEEEE",
    color: "#535362",
    fontSize: "11px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    padding: "8px",
    height: "28px",
    borderRadius: "6px",
  },
  unmanagedIcon: {
    width: "16px",
  },
  unmanagedTitle: {
    position: "relative", top: "1px",
    color: "#535362",
    fontWeight: 600
  }
}));

export default useStyles;
